import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';

import SEO from '../components/SEO';
import '../styles/Auth.css';

const EmailConfirmedPage = () => {
  const [status, setStatus] = useState('verifying');

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const tokenHash = params.get('token_hash');
        const type = params.get('type') || 'signup';

        if (tokenHash) {
          const { error } = await supabase.auth.verifyOtp({
            token_hash: tokenHash,
            type: type,
          });

          if (error) {
            setStatus('error');
          } else {
            await supabase.auth.signOut();
            window.sessionStorage.clear();
            setStatus('confirmed');
          }
        } else {
          const { data: { session } } = await supabase.auth.getSession();
          if (session) {
            await supabase.auth.signOut();
            window.sessionStorage.clear();
            setStatus('confirmed');
          } else {
            setStatus('error');
          }
        }
      } catch (err) {
        setStatus('error');
      }
    };

    const timer = setTimeout(verifyEmail, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="auth-page">
      <SEO title="Email Confirmed" path="/email-confirmed" noindex={true} />
      <div className="auth-left">
        <div className="auth-logo">
          <Link to="/" className="auth-logo-link">
            <img src="/pathproxy.png" alt="PathProxy Logo" className="auth-logo-image" />
            <span className="brand-name">pathproxy</span>
          </Link>
        </div>

        <div className="auth-form-container">
          {status === 'verifying' && (
            <div className="success-message">
              <div className="btn-spinner" style={{ width: '48px', height: '48px', margin: '0 auto 24px' }}></div>
              <h1>Verifying...</h1>
              <p>Please wait while we confirm your email address.</p>
            </div>
          )}

          {status === 'confirmed' && (
            <div className="success-message">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#E8FF00" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22,4 12,14.01 9,11.01"/>
              </svg>
              <h1>Email Confirmed!</h1>
              <p>Your email address has been successfully verified.</p>
              <p className="auth-subtitle">Your account is now active. You can log in and start using PathProxy.</p>
              <Link to="/login" className="auth-submit-btn" style={{ display: 'inline-block', textDecoration: 'none', marginTop: '20px' }}>
                Go to Login
              </Link>
            </div>
          )}

          {status === 'error' && (
            <div className="success-message">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ff4444" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <line x1="15" y1="9" x2="9" y2="15"/>
                <line x1="9" y1="9" x2="15" y2="15"/>
              </svg>
              <h1>Verification Failed</h1>
              <p>The confirmation link is invalid or has expired.</p>
              <p className="auth-subtitle">Please try signing up again or contact support.</p>
              <Link to="/signup" className="auth-submit-btn" style={{ display: 'inline-block', textDecoration: 'none', marginTop: '20px' }}>
                Sign Up Again
              </Link>
            </div>
          )}
        </div>
      </div>

      <div className="auth-right">
      </div>
    </div>
  );
};

export default EmailConfirmedPage;
